import { Pipe, PipeTransform } from '@angular/core';
import { CartItemType } from '@features/cart-item/types/cart-item.type';
import { OrderItemType } from '@rd/types/order-item.type';

interface OrderItemDescriptionParams {
  productType: OrderItemType | CartItemType;
  productName: string;
  displayValue: number;
  plural?: boolean;
}

@Pipe({
  name: 'orderItemDescription',
})
export class OrderItemDescriptionPipe implements PipeTransform {
  // TODO: Add currencyService here
  public transform({
    productType,
    productName,
    displayValue,
    plural = false,
  }: OrderItemDescriptionParams): string {
    if (
      [OrderItemType.GiftCardOrderItem, 'gift_card', 'digital'].includes(
        productType,
      )
    ) {
      return (
        `$${displayValue} ${productName} Digital Gift Card` +
        (plural ? 's' : '')
      );
    } else if (
      [
        OrderItemType.PhysicalGiftCardOrderItem,
        'physical_gift_card',
        'physical',
      ].includes(productType)
    ) {
      return (
        `$${displayValue} ${productName} Physical Gift Card` +
        (plural ? 's' : '')
      );
    }

    return productName;
  }
}
